/** @format */

import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

export const actionTypes = {
  getAllOwnerInfo: "[getAllDriverInfo] Action",
  getAllImages: "[getAllImages] Action",
}

const initialCountreiesState = {
  ownerInfo: {
    owner: {
      firstName: "",
      lastName: "",
      fatherName: "",
      nationalCode: "",
      idNumber: "",
      postalCode: "",
      phone: "",
      address: "",
      townshipId: null,
      birthDate: "",
    },
    car: {
      brandId: "",
      vin: "",
      chassicNumber: "",
      color: "",
      companyName: "",
      engineNumber: "",
      insuranceDate: "",
      insuranceNumber: "",
      model: "",
      ownerStats: "",
      plateNumber: "",
      plateSeries: "",
      seatNumber: "",
      seatNumber: "",
      smartCardNumber: "",
      tip: "",

      // vin: "",
    },
  },
  images: [],
}

export const reducer = persistReducer(
  { storage, key: "v705-demo1-auth", whitelist: ["user", "cars"] },
  (state = initialCountreiesState, action) => {
    switch (action.type) {
      case actionTypes.getAllOwnerInfo: {
        const ownerInfo = action.payload
        return { ...state, ownerInfo }
      }
      case actionTypes.getAllImages: {
        const images = action.payload
        return { ...state, images }
      }
      default:
        return state
    }
  }
)

export const actions = {
  getAllOwnerInfo: (payload) => ({
    type: actionTypes.getAllOwnerInfo,
    payload,
  }),
  getAllImages: (payload) => ({
    type: actionTypes.getAllImages,
    payload,
  }),
}
